import axios from '../localAxios';
import { WorkspaceQuiz } from './quiz/types';
import { copyToPersonalURL } from './workspacesURLs';

export type CopyWorkspaceQuizToPersonalParams = {
  workspaceId: string;
  workspaceQuizIds: string[];
};

export async function copyWorkspaceQuizToPersonal({
  workspaceId,
  workspaceQuizIds,
}: CopyWorkspaceQuizToPersonalParams) {
  const url = copyToPersonalURL();

  const result = await axios.post<WorkspaceQuiz[]>(url.href, {
    workspace_quiz_ids: workspaceQuizIds,
    workspace_id: workspaceId,
  });
  return result.data;
}
